import { createBrowserRouter, RouterProvider } from 'react-router';
import { Home } from './pages/Home';
import { GuestEntry } from './pages/GuestEntry';
import { Kiosk } from './pages/Kiosk';

const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/j/:token', element: <GuestEntry /> },
  { path: '/borne/:token', element: <Kiosk /> },
  { path: '*', element: <Home /> },
]);

export function App() {
  return <RouterProvider router={router} />;
}
